export const TRADE_PAGE_CONTAINER_PADDING_X = 12;
